import { ApplicationUser } from 'types/company/applicationUser';

type MessageStatus = 'sent' | 'delivered' | 'read' | string;
/** Normalized direction used across UI / Redux (`Type` field). */
type MessageDirection = 'outcoming' | 'incoming';

/**
 * Direction strings from HTTP/socket payloads. Servers typically send `outgoing`;
 * our UI and DB-style typing use `outcoming` for outbound messages.
 */
type ServerMessageFlow = 'incoming' | 'outgoing' | 'Incoming' | 'Outgoing';

/**
 * Maps API/server `outgoing` → UI `outcoming`. Idempotent for `outcoming` / `incoming`.
 * Empty or unknown values default to `incoming` (safe default for history rows).
 */
function normalizeChatMessageFlow(raw: string | null | undefined): MessageDirection {
  const s = raw == null ? '' : String(raw).trim().toLowerCase();
  if (s === 'outgoing' || s === 'outcoming') return 'outcoming';
  if (s === 'incoming') return 'incoming';
  return 'incoming';
}

/**
 * Like {@link normalizeChatMessageFlow}, but preserves non-standard `Type` strings
 * (e.g. legacy search payloads) instead of coercing them to `incoming`.
 */
function coerceServerMessageTypeToUi(raw: string | null | undefined): MessageDirection | string | undefined {
  if (raw == null || !String(raw).trim()) return undefined;
  const s = String(raw).trim().toLowerCase();
  if (s === 'outgoing' || s === 'outcoming') return 'outcoming';
  if (s === 'incoming') return 'incoming';
  return String(raw);
}
type MessageMediaType =
  | 'image'
  | 'video'
  | 'document'
  | 'audio'
  | 'text'
  | 'template'
  | 'note'
  | 'error'
  | 'buffer'
  | 'info'
  | 'reaction'
  | 'pdf'
  | 'docx'
  | 'xlsx'
  | 'zip'
  | 'gif'
  | 'sticker'
  | 'buttons'
  | 'contacts'
  | 'order'
  | 'catalog'
  | 'location'
  | 'reply'
  | string;
type MessageAssigneeType = ApplicationUser | { Udid: string; FullName: string } | undefined;

export type { MessageStatus, MessageDirection, MessageMediaType, MessageAssigneeType, ServerMessageFlow };
export { normalizeChatMessageFlow, coerceServerMessageTypeToUi };
